import React, { useContext, useState } from "react";
import classNames from "classnames/bind";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import Logo from "src/components/Logo";
import { Input } from "./components";

// context
import { AdminAuthContext } from "src/context/AdminAuthContext";

// hook
import { useRefMounted } from "src/custom_hooks/useRefMounted";

// assets
import ThreeDots from "src/assets/icons/ThreeDots";

import styles from "./AdminLogin.module.scss";
const cx = classNames.bind(styles);

const AdminLoginContent = () => {
  const { login } = useContext(AdminAuthContext);

  const isMountedRef = useRefMounted();
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSumbit = async () => {
    try {
      setIsLoading(true);
      await login(email, password);

      if (isMountedRef()) {
        history.push("/dashboard");
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message);
      setIsLoading(false);
    }
  };

  return (
    <div className={cx("admin-login-root")}>
      <div className={cx("form-content")}>
        <Logo wrapperClass={cx("logo-wrapper")} />
        <div className={cx("input-group")}>
          <Input
            label="Email"
            size="xs"
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            label="Password"
            size="xs"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button onClick={handleSumbit}>
          {isLoading ? <ThreeDots /> : "Login"}
        </button>
      </div>
    </div>
  );
};

export default AdminLoginContent;
